<div>
  <div class="row m-0">
    <div
      class="col-md-6 col-sm-6 col-lg-6 login_banner"
      [style.background-image]="'url(' + loginbanner + ')'"
      style="
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        height: 100vh;
      "
    ></div>
    <ng-container *ngIf="!forgotpasswordflag" class="login-container p-0">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div
          class="d-flex justify-content-center form-section align-items-center auth-container"
        >
          <div class="auth-wrapper">
            <div class="welcome-message" *ngIf="!formload_flag">
              <h1 translate class="text-center mb-3">
                Welcome to Ambedkar Educational Institutions
              </h1>
              <p translate class="text-muted">Please Select the Option below to login</p>
            </div>

            <div class="auth-card">
              <div [ngClass]="{ 'card-body p-4': formload_flag }">
                <!-- Role selector with better visual feedback -->
                 @if(usermsg && !loading){
                    <div style="color: red;text-align: center;">{{usermsg}}!</div>
                 }
                 <span></span>
                <div class="role-selector mb-4">
                  <mat-button-toggle-group
                    [hideSingleSelectionIndicator]="true"
                    appearance="legacy"
                    #group="matButtonToggleGroup"
                    [value]="selectedrole || null"
                    (change)="onValChange(group.value)"
                    class="role-toggle-group w-100"
                  >
                    <mat-button-toggle
                      value="student"
                      class="role-toggle flex-grow-1 text-center"
                    >
                      <div class="toggle-content">
                        <i class=" toggle-icon fa-solid fa-graduation-cap"></i>
                        <span translate>Student</span>
                      </div>
                    </mat-button-toggle>
                    <mat-divider [vertical]="true"></mat-divider>

                    <mat-button-toggle
                      value="staff"
                      class="role-toggle flex-grow-1 text-center"
                    >
                      <div class="toggle-content">
                        <i class="toggle-icon fa-solid fa-briefcase"></i>
                        <span translate>Staff</span>
                      </div>
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                  <div *ngIf="roles.length === 1" class="role-indicator">
                    <p class="text-center mb-0">
                      <mat-icon>person</mat-icon>
                      <span translat>Logging in as </span><strong>{{ roles[0].display }}</strong>
                    </p>
                  </div>
                </div>

                <!-- <div class="dynamic-header mb-3" *ngIf="formload_flag">
                  <p class="text-center text-muted small">
                    Please enter your {{ group.value }} credentials
                  </p>
                </div> -->

                <ng-container *ngIf="formload_flag">
                  <form
                    [formGroup]="form"
                    (ngSubmit)="onSubmit()"
                    class="auth-form"
                  >
                    <!-- Email Field -->
                    <div class="form-floating mb-3">
                      <input
                        type="email"
                        class="form-control"
                        id="userid"
                        placeholder="name@example.com"
                        formControlName="userid"
                        [ngClass]="{
                          'is-invalid': submitted && f['userid'].errors
                        }"
                        autocomplete="username"
                      />
                      <label for="userid">
                        {{ selectedrole | titlecase }} Email ID
                      </label>
                      <div
                        class="invalid-feedback"
                        *ngIf="submitted && f['userid'].errors"
                      >
                        <div translate *ngIf="f['userid'].errors['required']">
                          Email is required
                        </div>
                        <div translate *ngIf="f['userid'].errors['email']">
                          Please enter a valid email
                        </div>
                      </div>
                    </div>

                    <!-- Password Field -->
                    <div class="form-floating mb-3 password-field">
                      <input
                        [type]="showPassword ? 'text' : 'password'"
                        class="form-control"
                        id="password"
                        placeholder="Password"
                        formControlName="password"
                        [ngClass]="{
                          'is-invalid': submitted && f['password'].errors
                        }"
                        autocomplete="current-password"
                      />
                      <label for="password"
                        >{{ selectedrole | titlecase }} Password</label
                      >
                      <button
                        type="button"
                        class="btn btn-sm btn-link password-toggle"
                        (click)="showPassword = !showPassword"
                        [attr.aria-label]="
                          showPassword ? 'Hide password' : 'Show password'
                        "
                      >
                      <span *ngIf="!showPassword"><i class="fa-solid fa-eye"></i></span>
                      <span *ngIf="showPassword"><i class="fa-solid fa-eye-slash"></i></span>
                      </button>
                      <div
                        class="invalid-feedback"
                        *ngIf="submitted && f['password'].errors"
                      >
                        <div translate *ngIf="f['password'].errors['required']">
                          Password is required
                        </div>
                        <div translate="" *ngIf="f['password'].errors['minlength']">
                          Password must be at least 6 characters
                        </div>
                        <div translate *ngIf="f['password'].errors['maxlength']">
                          Password must not exceed 40 characters
                        </div>
                      </div>
                    </div>

                    <!-- Remember me & forgot password -->
                    <div
                      class="d-flex justify-content-between align-items-center mb-4"
                    >
                      <a translate
                        href="javascript:void(0)"
                        class="text-primary"
                        (click)="forgotflag()"
                        >Forgot password?</a
                      >
                    </div>
                    <ng-container *ngIf="loginerror">
                      <div class="custom-alert alert-danger">
                        <div class="alert-content">
                          <mat-icon class="alert-icon">error_outline</mat-icon>
                          <div class="alert-message">
                            <strong translate>Login failed!</strong> <span translate>Credentials don't
                            match our records.</span>
                          </div>
                          <button
                            type="button"
                            class="alert-close"
                            aria-label="Close"
                            (click)="loginerror = false"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Submit button with loading state -->
                    <button
                      class="btn w-100 py-2 auth-submit-btn"
                      type="submit"
                      [disabled]="loading"
                      matRipple
                    >
                      <span translate *ngIf="!loading">Login</span>
                      <span *ngIf="loading">
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span translate>Signing in...</span>
                      </span>
                    </button>
                  </form>
                </ng-container>
              </div>
            </div>

            <div class="terms-text mt-3 text-center text-muted">
              <small><span translate>By logging in, you agree to our</span><a class="mx-1" href="#"><span translate> Terms of Use </span></a> <span translate> and </span> <a href="#"><span class="mx-1" translate> Privacy Policy </span></a></small>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="forgotpasswordflag">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <app-forgotpassword
          [roleID]="selectedrole"
          (disableflags)="addItem($event)"
        ></app-forgotpassword>
      </div>
    </ng-container>
  </div>
</div>
